import React, { Fragment, ChangeEvent, useState } from 'react';
import { useTranslate, TextInput, required, SelectInput } from 'react-admin';
import { useForm } from 'react-final-form';

import { l } from './PnlAccountList';
import { BranchSelect } from '~/components/ra';

import { useTenantProducts } from '~/hooks/tenant';
import { useProductTemplates } from '~/hooks/useProductTemplates';

const PnlAccountForm = (props: any) => {
  const { edit, record } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const form = useForm();

  const { data: products } = useTenantProducts();
  const { data: productTemplates } = useProductTemplates();

  const [selectedProductId, setSelectedProductId] = useState<string | undefined>(record?.productId);

  const selectedProduct = products?.find((p) => p.id === selectedProductId);
  const selectedProductTemplate = productTemplates?.find(
    (pt) => pt.code === selectedProduct?.templateCode
  );

  const handleProductChange = (e: ChangeEvent<{ name: string; value: string }>) => {
    const productId = e.target.value;
    setSelectedProductId(productId);

    const product = products?.find((p) => p.id === productId);
    const productTemplate = productTemplates?.find((pt) => pt.code === product?.templateCode);

    form.change('display.type', productTemplate?.category);
    form.change(
      'display.glType',
      productTemplate?.glType &&
        translate(`components.ra.fields.GlTypeIcon.${productTemplate.glType}`)
    );
    form.change(
      'display.regulatoryType',
      product?.regulatoryType &&
        translate(`components.ra.fields.RegulatoryType.${product.regulatoryType}`)
    );
  };

  const allowEditProduct =
    record &&
    products &&
    (record.profileId === record.productId || !products?.find((p) => p.id === record.productId));

  return (
    <Fragment>
      <TextInput source='name' label={t('accountName')} />
      {!edit && (
        <SelectInput
          onChange={handleProductChange}
          source='productId'
          label={t('productId')}
          choices={products || []}
          validate={required()}
          disabled={!products}
        />
      )}
      {!edit && (
        <Fragment>
          <TextInput source='number' label={t('number')} />
          <BranchSelect source='branch' record={record} allowEmpty />
        </Fragment>
      )}
      <TextInput source='alias' label={t('alias')} validate={required()} />
      <TextInput source='description' label={t('description')} />
      {!edit && selectedProduct && (
        <Fragment>
          <TextInput
            disabled
            label={t('type')}
            source='display.type'
            defaultValue={selectedProductTemplate?.category}
          />
          <TextInput
            disabled
            label={t('glType')}
            source='display.glType'
            defaultValue={
              selectedProductTemplate?.glType &&
              translate(`components.ra.fields.GlTypeIcon.${selectedProductTemplate.glType}`)
            }
          />
          <TextInput
            disabled
            label={t('regulatoryType')}
            source='display.regulatoryType'
            defaultValue={
              selectedProduct.regulatoryType &&
              translate(`components.ra.fields.RegulatoryType.${selectedProduct.regulatoryType}`)
            }
          />
        </Fragment>
      )}
      {allowEditProduct && (
        <SelectInput
          choices={products || []}
          source='productId'
          validate={required()}
          disabled={!products}
        />
      )}
    </Fragment>
  );
};

export default PnlAccountForm;
